/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
import React, { forwardRef } from 'react';
// eslint-disable-next-line react/display-name
var Tab = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    className = props.className,
    children = props.children,
    active = props.active,
    label = props.label,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    propsTabId = props.tabId,
    ariaId = props.ariaId;
  var randomID = String.fromCharCode(65 + Math.floor(Math.random() * 26)) + Date.now();
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    role: "tabpanel",
    "aria-labelledby": propsTabId || "tab" + (label ? '-' + label : '') + "-" + randomID,
    className: className,
    hidden: !active,
    style: style,
    id: ariaId
  }, children);
});
export default Tab;